import { render } from "./TheUserWorkspace.vue?vue&type=template&id=4d9c46c1"
import script from "./TheUserWorkspace.vue?vue&type=script&lang=js"
export * from "./TheUserWorkspace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__